module.exports = __webpack_public_path__ + "static/media/Gif-Box.1b6c7dfc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/video/Gif-Box.mp4
// module id = 67
// module chunks = 0